import { useContext } from "react";
import RouteContext from "../context/RouteContext";
import { Outlet } from "react-router-dom";
import LogoWait from "../assets/images/LogoWait.png";
import LoginWoxa from "../assets/images/Logowoxalogin.png";
import FridaySpecialModal from "./FridaySpecialModal";

const AppOutlet = () => {
  const { isInitialized } = useContext(RouteContext);
  return (
    <div className="Page">
      {!isInitialized && (
        <div className="flex flex-col justify-center h-screen items-center bg-white">
          <img src={LogoWait} alt="waiting..." className="w-auto h-[168px] flex" />
          <div className="font-nunito font-medium text-secondary-S600 text-xl">
            Wait a sec...
          </div>
          <footer className="fixed mb-20 bottom-0 left-0 right-0 flex justify-center">
          <img src={LoginWoxa} alt="Logo" className="w-[134px] h-auto" />
        </footer>
        </div>
      )}
      <Outlet />
      <FridaySpecialModal />
    </div>
  );
};

export default AppOutlet;
